export default __webpack_public_path__ + "static/media/kanye2.29e0ed46.jpeg";